import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import { colors } from 'app-v2/design-systems/theme/colors'
import { COLOR } from 'app-v2/design-tokens'
import { Button } from 'app-v2/design-systems/components/inputs/button'
import { BodyText } from 'app-v2/design-systems/typography/text'
import Modal from 'react-modal'
import { Close } from 'app/assets/icons'
import { style } from 'app/assets/styles'
import { H3 } from 'app/common/typography'
import { KingdomNoBlazon } from 'app-v2/assets/icons/KingdomNoBlazon'
import {
    StyledBody,
    StyledButtonContainer,
    StyledCloseButtonContainer,
    StyledCoverBackground,
    StyledKingdomNoBlazonContainer
} from './styles'
import { useHistory } from 'react-router-dom'

type AuthenticationDuringOrderProps = {
    visible: boolean,
    setVisible: (visible: boolean) => void,
    redirectTo?: string
}

export const AuthenticationDuringOrder = ({
    setVisible,
    visible,
    redirectTo
}: AuthenticationDuringOrderProps) => {
    const close = useCallback(() => setVisible(false), [setVisible])
    const intl = useIntl()
    const history = useHistory()
    return (
        <Modal
            isOpen={visible}
            ariaHide={false}
            shouldCloseOnOverlayClick
            onRequestClose={close}
            style={style.classicModalStyle}>
            <StyledCloseButtonContainer onClick={close}>
                <Close color={COLOR.PRIMARY} size={24} />
            </StyledCloseButtonContainer>
            <Cover />
            <StyledBody>
                <H3>
                    {intl.formatMessage({
                        id: 'ecommerce.logInModal.title'
                    })}
                </H3>
                <BodyText>
                    {intl.formatMessage({
                        id: 'ecommerce.logInModal.explainKingdom'
                    })}
                </BodyText>
                <StyledButtonContainer>
                    <Button
                        fullLength
                        buttonColor={COLOR.PRIMARY}
                        labelColor={colors.white}
                        onClick={() => {
                            setVisible(false)
                            history.push(
                                intl.formatMessage({
                                    id: 'routes.clickandcollect.signin.signup'
                                }),
                                {
                                    fromUrl:
                                        redirectTo ||
                                        intl.formatMessage({
                                            id: 'routes.clickandcollect.catalog'
                                        })
                                }
                            )
                        }}>
                        {intl.formatMessage({
                            id: 'ecommerce.logInModal.continueWithKingdom'
                        })}
                    </Button>
                    <Button
                        fullLength
                        variant={'outlined'}
                        buttonColor={COLOR.PRIMARY}
                        labelColor={COLOR.PRIMARY}
                        onClick={() => {
                            setVisible(false)
                            history.push(
                                redirectTo ||
                                    intl.formatMessage({
                                        id: 'routes.clickandcollect.catalog'
                                    })
                            )
                        }}>
                        {intl.formatMessage({
                            id: 'ecommerce.logInModal.continueWithoutKingdom'
                        })}
                    </Button>
                </StyledButtonContainer>
            </StyledBody>
        </Modal>
    )
}

const Cover = () => (
    <StyledCoverBackground>
        <StyledKingdomNoBlazonContainer>
            <KingdomNoBlazon width={90} />
        </StyledKingdomNoBlazonContainer>
    </StyledCoverBackground>
)
